import React from "react";
import PropTypes from "prop-types";
import { PaymentElement } from "@stripe/react-stripe-js";

const DEFAULT_OPTIONS = { layout: "tabs" };

const StripePaymentMethod = ({ className = null, options = DEFAULT_OPTIONS }) => {
  return (
    <div className={className}>
      <PaymentElement options={options} />
    </div>
  );
};

StripePaymentMethod.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object
};

export default StripePaymentMethod;
